import { useNavigate, useParams } from 'react-router-dom';

export function useLangNavigate() {
  const navigate = useNavigate();
  const { lang } = useParams();

  return (to, options = {}) => {
    if (!lang) return navigate(to, options); // fallback
    // Avoid double-slash or duplicate lang
    const fullPath = to.startsWith('/') ? `/${lang}${to}` : `/${lang}/${to}`;
    navigate(fullPath, options);
  };
}
